// File: frontend/src/components/entries/CollapsedEntriesBar.tsx

import React from "react";
import { useTranslation } from "react-i18next";
import "./CollapsedEntriesBar.css";

interface CollapsedEntriesBarProps {
  // How many older entries are still hidden behind the bar
  hiddenCount: number;
  // Loading state while the previous chunk is being fetched
  isLoading: boolean;
  // Reveals the previous chunk of older entries
  onClick: () => void;
}

/**
 * "{count} entry daha" bar rendered above today's entries
 * when older entries are collapsed. Clicking it reveals the previous chunk.
 * Shared by all five entry domains (match, person, club, team, custom topic).
 */
export const CollapsedEntriesBar: React.FC<CollapsedEntriesBarProps> = ({
  hiddenCount,
  isLoading,
  onClick,
}) => {
  const { t } = useTranslation();

  // Nothing left to reveal — the bar disappears
  if (hiddenCount <= 0) return null;

  return (
    <button
      className="collapsed-entries-bar"
      onClick={onClick}
      disabled={isLoading}
    >
      {isLoading
        ? t("load_more_loading", "yükleniyor...")
        : t("load_more_entries", "{{count}} entry daha", { count: hiddenCount })}
    </button>
  );
};